import * as colors from 'utils/constants/theme';

/**
 * AXON-3585: discipline swatches, reusing the appointment-type colours already
 * in use. Shared by both levels so a discipline keeps one colour as a user
 * drills in — the swatch is how the two tables are read as the same subject.
 */
export const DISCIPLINE_COLOURS: { [discipline: string]: string } = {
  OT: colors.AT_2,
  SLP: colors.AT_4,
  MT: colors.AT_6
};
